/**
 * sign 签名规则
 */


import md5 from 'js-md5';
import qs from 'qs'; // 根据需求是否导入 qs 模块

const base = process.env; // 导入接口域名列表

// 格式化参数成 key=value&key=value
const formatParams = params => {
    // 添加时间戳
    let timestamp1 = (new Date()).valueOf();
    params['timestamp'] = parseInt(timestamp1/1000)

    // 重新排序
    let paramsSort = {}
    let keys = Object.keys(params).sort()
    keys.forEach(item => {
        paramsSort[item] = params[item]
    })
    return qs.stringify(paramsSort) || ''
}


const sign = {
    // 业务签名
    main (params = {}) {
        
        let _params = JSON.stringify(params)
        _params = JSON.parse(_params)
        // 拼接 key
        let _string = md5(formatParams(_params) + '&' + base.VUE_APP_KEY)
        // 大写
        _params['sign'] = _string.toUpperCase()

        return _params
    },
    /*
        other 其他签名
        支付 PAY
        短信 SMS
    */
    other (params, type) {

        let _params = JSON.stringify(params)
        _params = JSON.parse(_params)
        _params['app_id'] = base[`VUE_APP_${ type }_APP_ID`]
        // 拼接 key
        let _string = md5(`${ formatParams(_params) }&app_secret=${ base[`VUE_APP_${ type }_APP_SECRET`] }`)
        // 大写
        _params['sign'] = _string.toUpperCase()

        return _params
    },
    
}

export default sign;


// WEBPACK FOOTER //
// ./src/api/libs/sign.js